import { useMemo } from "react";
import { motion } from "framer-motion";

export default function NightSky({ count = 130 }) {
  const stars = useMemo(
    () =>
      Array.from({ length: count }, (_, i) => ({
        id: i,
        left: Math.random() * 100,
        top: Math.random() * 100,
        size: 1 + Math.random() * 2.5,
        dur: 1.5 + Math.random() * 3,
        delay: Math.random() * 3,
      })),
    [count]
  );

  return (
    <div className="pointer-events-none fixed inset-0 z-0 overflow-hidden" aria-hidden="true">
      {stars.map((s) => (
        <motion.span
          key={s.id}
          className="absolute rounded-full bg-white"
          style={{ left: `${s.left}%`, top: `${s.top}%`, width: s.size, height: s.size }}
          animate={{ opacity: [0.15, 1, 0.15] }}
          transition={{ duration: s.dur, delay: s.delay, repeat: Infinity, ease: "easeInOut" }}
        />
      ))}
      <motion.div
        className="absolute h-0.5 w-28 rounded-full"
        style={{
          top: "10%",
          left: "100%",
          rotate: -22,
          background: "linear-gradient(to right, #ffffff, transparent)",
        }}
        animate={{ x: [0, -1600], y: [0, 520], opacity: [0, 1, 1, 0] }}
        transition={{ duration: 2, repeat: Infinity, repeatDelay: 6, ease: "easeOut" }}
      />
    </div>
  );
}
